import React from "react"
import { AnchorLink } from "gatsby-plugin-anchor-links"

const AlphabetSelector = ({ alphabetCount, title, subtitle }) => {
  return (
    <>
      <h2 className={"display-4"}>
        {title || "Alphabet-Selektor"}

        {
          subtitle &&
          <p>{subtitle}</p>
        }
      </h2>
      <div className="AlphabetNav">
        {
          Object.keys(alphabetCount).sort((a, b) =>
            a.localeCompare(b, "de", { sensitivity: "base" }) || a.localeCompare(b, "de")
          ).map((key) => (
            <div key={key}>
              <AnchorLink to={"#" + alphabetCount[key].id} title={key}>
                {key}
              </AnchorLink>
            </div>
          ))
        }
      </div>
    </>
  )
}

export default AlphabetSelector
